<template>
    <i class="fa-regular fa-trash-can cursor:pointer color:primary:hover" @click="modal.show(id)"></i>
    <topic-remove-modal @remove="emit('remove')" ref="modal"></topic-remove-modal>
</template>

<script setup>
    const modal = ref();

    const emit = defineEmits(["remove"]);

    defineProps({
        id: { required: true, type: Number }
    });
</script>
